import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "className", "disabled", "type", "size", "invalid", "invalidText", "invalidTextId", "warn", "warnText", "warnTextId", "light", "isOpen"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import cx from 'classnames';
import React, { forwardRef, useContext } from 'react';
import { deprecate } from '../../prop-types/deprecate.js';
import './index.js';
import { usePrefix } from '../../internal/usePrefix.js';
import '../FluidForm/FluidForm.js';
import { FormContext } from '../FluidForm/FormContext.js';
import { ListBoxTypePropType, ListBoxSizePropType } from './ListBoxPropTypes.js';
var handleOnKeyDown = function handleOnKeyDown(event) {
  if (event.keyCode === 27) {
    event.stopPropagation();
  }
};
var handleClick = function handleClick(event) {
  event.preventDefault();
  event.stopPropagation();
};
/**
 * `ListBox` is a generic container component that handles creating the
 * container class name in response to certain props.
 */
var ListBox = /*#__PURE__*/forwardRef(function (props, ref) {
  var _objectSpread2;
  var children = props.children,
    containerClassName = props.className,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$type = props.type,
    type = _props$type === void 0 ? 'default' : _props$type,
    size = props.size,
    invalid = props.invalid,
    invalidText = props.invalidText,
    invalidTextId = props.invalidTextId,
    warn = props.warn,
    warnText = props.warnText,
    warnTextId = props.warnTextId,
    light = props.light,
    isOpen = props.isOpen,
    rest = _objectWithoutProperties(props, _excluded);
  var prefix = usePrefix();
  var _useContext = useContext(FormContext),
    isFluid = _useContext.isFluid;
  var showWarning = !invalid && warn;
  var className = cx(_objectSpread(_objectSpread({}, containerClassName && _defineProperty({}, containerClassName, true)), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, "".concat(prefix, "--list-box"), true), _defineProperty(_objectSpread2, "".concat(prefix, "--list-box--").concat(size), size), _defineProperty(_objectSpread2, "".concat(prefix, "--list-box--inline"), type === 'inline'), _defineProperty(_objectSpread2, "".concat(prefix, "--list-box--disabled"), disabled), _defineProperty(_objectSpread2, "".concat(prefix, "--list-box--light"), light), _defineProperty(_objectSpread2, "".concat(prefix, "--list-box--expanded"), isOpen), _defineProperty(_objectSpread2, "".concat(prefix, "--list-box--invalid"), invalid), _defineProperty(_objectSpread2, "".concat(prefix, "--list-box--warning"), showWarning), _objectSpread2)));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: className,
    ref: ref,
    onKeyDown: handleOnKeyDown,
    onClick: handleClick,
    "data-invalid": invalid || undefined
  }), children), isFluid && /*#__PURE__*/React.createElement("hr", {
    className: "".concat(prefix, "--list-box__divider")
  }), invalid ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "--form-requirement"),
    id: invalidTextId
  }, invalidText) : null, showWarning ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "--form-requirement"),
    id: warnTextId
  }, warnText) : null);
});
ListBox.displayName = 'ListBox';
export { ListBox as default };